import { render } from "./confirm-sales.vue?vue&type=template&id=4c442c2e"
import script from "./confirm-sales.vue?vue&type=script&lang=js"
export * from "./confirm-sales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__